/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.4;
  }
`;

const bubbleFadeInOut = keyframes`
  0%,
  80%,
  100% {
    box-shadow: 0 10px 0 -5px;
  }
  40% {
    box-shadow: 0 10px 0 0;
  }
`;

export default $ => css`
  div.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }

  div.fullscreen > div {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  div.loader-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  div.loader-container.centered {
    justify-content: center;
  }

  div.loader-container.centered > .children {
    padding-right: 4rem;
  }

  div.loader-container > div {
    margin-left: 1em;
  }

  .logo-loader {
    animation: ${pulse} 1.3s infinite ease-in-out;
  }

  .dots-loader,
  .dots-loader:before,
  .dots-loader:after {
    opacity: 0.7;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    animation-fill-mode: both;
    animation: ${bubbleFadeInOut} 1.3s infinite ease-in-out;
  }

  .dots-loader {
    top: -8px;
    color: ${$.primaryMain};
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }

  .dots-loader:before,
  .dots-loader:after {
    content: '';
    position: absolute;
    top: 0;
  }

  .dots-loader:before {
    left: -12px;
    animation-delay: -0.32s;
  }
  .dots-loader:after {
    left: 12px;
  }
`;
